if (window.ProductList!=undefined) {
  ProductList.prototype.getNoResultSearchTemplate=function() {
  return '\n			<div class="boost-pfs-filter-message result-empty-search">\n				<p>{{content}}</p>\n				<p><a href="/collections/most-wanted/">Shop Most Wanted ⟶</a></p>\n			</div>\n		'.trim();
};
}

var boostPFS = new BoostPFS();
  if (window.FilterApi!=undefined) {
  FilterApi.beforeCall=function(t,e) {
    if (BoostPFS.Utils.isSearchPage() && BoostPFS.jQ('[data-sort]').length==0) {
      FilterApi.setParam('sort','created-descending')
    }
  }
}
boostPFS.init(); 


if (typeof boostPFSConfig != 'undefined' 
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined' 
	&& boostPFSConfig.general.isInitFilter === true) { 
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
	boostPFS.initSearchBox();
	boostPFS.initAnalytics();
});